export const REACT_APP_SERVER_URL = 'http://localhost:8000/'
export const APP_NAME = 'Money Market Fund'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'